import React from 'react'

const Generator = () => {
  return (
    <div>Generator</div>
  )
}

export default Generator